import React from 'react';
import PropTypes from 'prop-types';
import './TripBoardHitNewModal.less';

function TripBoardHitNewModal({
    thumbnails,
    tripBoardTitle,
    ...rest
}) {
    return (
        <div {...rest} className="trip-board-hit-new-modal">
            <div className="trip-board-hit-new-modal__image-container">
                <div className="trip-board-hit-new-modal__image" style={{backgroundImage: thumbnails[0] ? `url(${thumbnails[0]})` : 'none'}} />
            </div>
                <div className="trip-board-hit-new-modal__title" >{tripBoardTitle}</div>
        </div>
    );
}

TripBoardHitNewModal.propTypes = {
    thumbnails: PropTypes.arrayOf(PropTypes.string),
    tripBoardTitle: PropTypes.string
};

TripBoardHitNewModal.defaultProps = {
    thumbnails: [],
    tripBoardTitle: ''
};

export default TripBoardHitNewModal;
